const events = [
  {code: 'fulfillment-mail-sent', title: 'Form Generated', category: '', sort: true, metadata: {
    provider: {
      type: 'select',
      values: ['kit', 'clinic/mobile']
    },
    requestedTests: {
      type: 'text', // Any of `Sto`, `Met`, `HTS' separated by a `+`
    }
  }},
  
  {code: 'meddx-opened-mail', title: 'Kit Request Received', category: 'Kit Fulfillment', sort: false, metadata: {}},
  {code: 'meddx-kit-sent', title: 'Kit Sent (to user)', category: 'Kit Fulfillment', sort: false, metadata: {} },
  {code: 'meddx-kit-received', title: 'Kit Received (by user)', category: 'Kit Fulfillment', sort: false, metadata: {}},

  {code: 'blood-draw-requested', title: 'Appointment Requested', category: 'Blood Draw', sort: true, metadata: {
    requestedDate: {
      type: 'datetime-local'
    },
    provider: {
      type: 'select',
      values: ['PathLab', 'Olive', 'County']
    },
    location: {
      type: 'text'
    },
    type: {
      type: 'select',
      values: ['Clinic', 'Mobile']
    },
    needleFlag: {
      type: 'select',
      values: [true, false]
    }
  }},
  {code: 'blood-draw-confirmed', title: 'Appointment Confirmed', category: 'Blood Draw', sort: true, metadata: {
    requestedDate: {
      type: 'datetime-local'
    },
    provider: {
      type: 'select',
      values: ['PathLab', 'Olive', 'County']
    },
    location: {
      type: 'text'
    },
    type: {
      type: 'select',
      values: ['Clinic', 'Mobile']
    },
    needleFlag: {
      type: 'select',
      values: [true, false]
    }
  }},
  
  {code: 'county-sample-sent', title: 'Sample Sent (to Clinical Lab)', category: 'Sample Delivery', sort: true, metadata: {
    lab: {
      type: 'select',
      values: ['County']
    },
    carrier: {
      type: 'select',
      values: ['gophr', 'royalmail', 'parcelforce', 'dhl']
    },
    trackingId: {
      type: 'text'
    },
    trackingStatus: {
      type: 'text'
    },
  }},
  {code: 'sample-arrived-clinical', title: 'Sample Arrived at Lab (Clinical)', category: 'Sample Delivery', sort: false, metadata: {
    lab: {
      type: 'select',
      values: ['County']
    },
    carrier: {
      type: 'select',
      values: ['gophr', 'royalmail', 'parcelforce', 'dhl']
    },
    trackingId: {
      type: 'text'
    },
    trackingStatus: {
      type: 'text'
    },
  }},
  {code: 'county-sample-arrived', title: 'Sample Processed (Clinical)', category: 'Sample Delivery', sort: true, metadata: {}},
  {code: 'county-result-posted', title: 'Clinical Results Processed (HL7)', category: 'Clinical Analysis', sort: true, metadata: {
    samplePassed: {
      type: 'select',
      values: [true, false]
    },
    roaPassed: {
      type: 'select',
      values: [true, false]
    },
  }},
  
  {code: 'dna-sample-sent', title: 'Eurofins Sample Sent (to DNA Lab)', category: 'Genomic Analysis', sort: false, metadata: {}},
  {code: 'dna-sample-arrived', title: 'Eurofins Sample Received (DNA)', category: 'Genomic Analysis', sort: false, metadata: {}},
  {code: 'dna-sample-booked', title: 'Sample Booked In (Eurofins)', category: 'Genomic Analysis', sort: true, metadata: {}},
  {code: 'methylation-analysis-started', title: 'DNAm Analysis Started', category: 'Genomic Analysis', sort: false, metadata: {}},
  {code: 'dna-methylation-result-posted', title: 'DNAm Results Posted', category: 'Genomic Analysis', sort: true, metadata: {
    lab: {
      type: 'select',
      values: ['county', 'eurofins', 'chronomics']
    }
  }},
  {code: 'genotyping-analysis-started', title: 'Genotyping Started', category: 'Genomic Analysis', sort: true, metadata: {}},
  {code: 'dna-genotyping-result-posted', title: 'Genotyping Results Posted', category: 'Genomic Analysis', sort: true, metadata: {
    lab: {
      type: 'select',
      values: ['county', 'eurofins', 'chronomics']
    },
    genotypingPass: {
      type: 'select',
      values: [true, false]
    },
    callRate: {
      type: 'number'
    }
  }},
  
  {code: 'bioinformatics-data-posted', title: 'DNAm Data Sent to Bioinformatics Provider', category: 'Bioinformatics', sort: true, metadata: {
    lab: {
      type: 'select',
      values: ['county', 'eurofins', 'chronomics']
    },
  }},
  {code: 'bioinformatics-notified', title: 'Bioinformatics Provider Notified', category: 'Bioinformatics', sort: true, metadata: {}},
  {code: 'bioinformatics-accessed-data', title: 'Data Reviewed by Bioinformatics Provider', category: 'Bioinformatics', sort: false, metadata: {}},
  {code: 'bioinformatics-report-posted', title: 'Bioinformatics DNAm BA Report Posted (Chronomics)', category: 'Bioinformatics', sort: true, metadata: {
    passQc: {
      type: 'select',
      values: [true, false]
    },
    passBmiq: {
      type: 'select',
      values: [true, false]
    }
  }},
  {code: 'physician-oversight-final-review', title: 'Physician Oversight Final Review', category: 'Physician Oversight', sort: true, metadata: {}},
  {code: 'physician-oversight-completed', title: 'Physician Oversight Completed', category: 'Physician Oversight', sort: true, metadata: {}},
  {code: 'rate-of-aging-calculated', title: 'Rate of Aging Posted (Clinical)', category: 'Humanity App', sort: true, metadata: {
    labResultId: {
      type: 'text'
    }
  }},
];

export default events;
